import PropTypes from 'prop-types';
import { noop } from 'lodash';
import React from 'react';
import { FDStack } from '@facet-wealth/design';
import LabellessTextField from 'Components/ComponentLibrary/Components/Uncategorized/LabellessTextField';
import TitleWithRequired from 'Components/ComponentLibrary/Molecules/TitleWithRequired/TitleWithRequired';

function TextFieldWithLabelAbove({
  value, onChange, hidden, readonly, placeholder, onBlur, InputProps, test, label, required, ...rest
}) {
  return (
    <FDStack direction={'column'} spacing={1}>
      <TitleWithRequired text={label} required={required} />
      <LabellessTextField
        value={value}
        onChange={onChange}
        hidden={hidden}
        readonly={readonly}
        placeholder={placeholder}
        onBlur={onBlur}
        InputProps={InputProps}
        test={test}
        {...rest}
      />
    </FDStack>
  );
}

TextFieldWithLabelAbove.defaultProps = {
  readonly: 'false',
  hidden: 'false',
  onChange: noop,
  onBlur: noop,
  value: undefined,
  InputProps: {},
  placeholder: '',
  test: '',
  label: '',
  required: 'false',
};

TextFieldWithLabelAbove.propTypes = {
  readonly: PropTypes.bool,
  hidden: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  value: PropTypes.string,
  InputProps: PropTypes.object,
  placeholder: PropTypes.string,
  test: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.bool,
};

export default TextFieldWithLabelAbove;
